const scope = "beach/";

export const fetch_paginated_beaches_saga = `${scope}fetch_paginated_beaches`;
export const fetch_beach_by_id_saga = `${scope}fetch_beach_by_id`;
export const create_new_beach_saga = `${scope}fetch_create_new_beach`;
export const create_beaches_saga = `${scope}create_beaches_saga`;
export const update_beach_saga = `${scope}update_new_beach_saga`;
export const delete_beach_saga = `${scope}delete_beach_saga`;
export const create_seat_saga = `${scope}create_seat_saga`;
export const delete_seat_saga = `${scope}delete_seat_saga`;
export const update_seat_saga = `${scope}update_seat_saga`;
